export default "__VITE_ASSET__OTeORJ1U__"